export default {
  name: "BeneficiaryDahsboard",

  data: () => ({
      entity_name: sessionStorage.getItem('entity_name'), 
  }),
};